import React from 'react';
import questionareStyle from '../../style';
import YesNo from '../YesNo';

export default function Slide2(props){
    let style = questionareStyle();

    return(
        <div>
            <p
             style={{
                ...{
                    marginTop: '1rem'
                },
                ...style.questionareText()
             }}
            >
                Do you like weight lifting? And want to build muscle tone?
            </p>
            <YesNo 
                nextPressed = {(answer) => {
                    props.nextPressed({
                        a2: answer
                    });
                }}
            />
        </div>
    );
}